<template>
  <div class="post-text-cta-container">
    <div class="post-text-cta">
      <div class="title is-size-3-desktop is-size-3-tablet is-size-3-mobile">
        Was kann man gegen eine Demenz oder frühe Demenz tun?
      </div>
      <div class="explanation">
        Sie suchen für sich selbst oder für einen Angehörigen nach einer Möglichkeit, den
        <span class="bold">Verlauf von früher Demenz zu verlangsamen</span> oder eine Demenz zu verhindern?<br /><br />

        Probieren Sie das wissenschaftliche Training mit der memodio-App <span class="bold">5 Tage gratis</span> aus.
      </div>
      <nuxt-link to="/"> Hier klicken für mehr Informationen! </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostTextCta",
}
</script>

<style scoped lang="scss">
.post-text-cta-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.post-text-cta {
  background-color: $brandpurple;
  border-radius: 20px;
  padding: 3rem 5rem;
  max-width: 600px;
  color: white;

  .title,
  a {
    color: white;
  }

  .explanation {
    font-size: 1.2rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  a {
    width: 100%;
    font-size: 24px;
    text-align: center;
  }

  @media (max-width: $tablet) {
    padding: 2rem 3rem;
    max-width: 100%;
  }
}

.bold {
  font-weight: 800;
}
</style>
